import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function OAuthCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const location_id = params.get('location_id');
    const state = params.get('state');

    if (error) {
      setStatus('error');
      setMessage(`OAuth error: ${error}`);
      setTimeout(() => navigate('/dashboard/integrations?oauth_error=' + encodeURIComponent(error)), 2000);
      return;
    }
    if (!code) {
      setStatus('error');
      setMessage('Missing code parameter');
      setTimeout(() => navigate('/dashboard/integrations?oauth_error=Missing+code+parameter'), 2000);
      return;
    }

    // Call backend Netlify function to exchange code for tokens
    const doExchange = async () => {
      try {
        let url = `/api/oauth-callback?code=${encodeURIComponent(code)}`;
        if (location_id) url += `&location_id=${encodeURIComponent(location_id)}`;
        if (state) url += `&state=${encodeURIComponent(state)}`;
        
        console.log('OAuth Callback: Calling Netlify function with URL:', url);
        console.log('OAuth Callback: Parameters:', { code: code?.substring(0, 10) + '...', location_id, state });
        
        const res = await fetch(url, { method: 'GET' });
        // The backend will redirect, but if not, handle fallback
        if (res.redirected) {
          window.location.href = res.url;
          return;
        }
        if (res.ok) {
          setStatus('success');
          setMessage('OAuth connection successful! Redirecting...');
          setTimeout(() => navigate('/dashboard/integrations?oauth_success=1'), 1500);
        } else {
          const data = await res.json().catch(() => ({}));
          setStatus('error');
          setMessage(data?.error || 'OAuth callback failed');
          setTimeout(() => navigate('/dashboard/integrations?oauth_error=' + encodeURIComponent(data?.error || 'OAuth callback failed')), 2000);
        }
      } catch (err: any) {
        setStatus('error');
        setMessage(err.message || 'OAuth callback failed');
        setTimeout(() => navigate('/dashboard/integrations?oauth_error=' + encodeURIComponent(err.message || 'OAuth callback failed')), 2000);
      }
    };
    doExchange();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded shadow-md max-w-md w-full text-center">
        <h2 className="text-xl font-semibold mb-4">Connecting to GoHighLevel...</h2>
        {status === 'loading' && <div className="text-gray-600">Please wait, finalizing connection.</div>}
        {status === 'success' && <div className="text-green-600">{message}</div>}
        {status === 'error' && <div className="text-red-600">{message}</div>}
      </div>
    </div>
  );
} 